module.exports = __webpack_public_path__ + "static/media/note.023a6516.png";